<template>
  <div class="page-wrapper">
    <TrfGlobalLoader v-if="isFormLoading" v-e2e="'form-loader'" type="fixed" />

    <div class="container" v-e2e="'formulario-tarefa-responder-container'" v-if="keyValida && !isFormLoading">
      <TrfHeader :pageTitle="pageTitle"></TrfHeader>
      <div
        v-if="ajustes"
        class="ajustes is-flex is-flex-direction-column is-align-items-center p-4 mb-4"
        v-e2e="'formulario-tarefa-ajustes'"
      >
        <b class="pb-3">Atenção!</b>
        <div class="content" v-html="ajustesSanitizado"></div>
      </div>
      
      <div class="is-flex is-justify-content-center" v-e2e="'formulario-tarefa-form-box'">
          <TrfPreenchimentoForm
            ref="formPreenchimento"
            :pFormData="formulario"
            :pIsPreenchimento="!isConferencia"
            :pIsConferencia="isConferencia"
            @update:form-data="setFormData"
          ></TrfPreenchimentoForm>
      </div>
      <hr />
      <div class="buttons is-flex is-justify-content-flex-end my-6">
        <TrfButton v-if="!isConferencia"
          id="btn-a-concluir-formulario"
          classCor="is-primary"
          nome="A concluir"
          :disabled="configsBtnsView.isLoading || isBtnAConcluirLoading"
          :is-btn-loading="isBtnAConcluirLoading"
          @click="async($event) => await aConcluirFormularioPelaKey($event)"
          title="Salvar os dados preenchidos e continuar depois."
        />
        <TrfButton
          id="btn-salvar-formulario"
          classCor="is-primary"
          :nome="configsBtnsView.labelConfirma"
          :disabled="configsBtnsView.isLoading || isBtnAConcluirLoading"
          :is-btn-loading="configsBtnsView.isLoading"
          @click="configsBtnsView.acaoConfirma"
          :title="tooltipConfirmar"
        />
        <TrfButton
          id="btn-cancelar-formulario"
          :nome="configsBtnsView.labelCancela"
          :disabled="configsBtnsView.isLoading || isBtnAConcluirLoading"
          @click="configsBtnsView.acaoCancela"
        />
      </div>
    </div>

    <div v-e2e="'formulario-tarefa-erro-nao-encontrado'" v-if="!keyValida">
      <TrfPaginaErro :tituloDeErro="tituloErroNaoEncontrado" :mensagemDeErro="mensagemErroNaoEncontrado" />
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import DOMPurify from 'dompurify';
import { toastUtils } from '../../../util/toast.utils.js';
import { routerUtils } from '../../../util/router.utils.js';
import FormularioTarefa from '../../../model/formulario-tarefa.model.js';
import { ToastBuilder, toastTypeEnum } from '../../../builder/toast.builder.js';

const formIncompletoToast = new ToastBuilder();
formIncompletoToast.setType(toastTypeEnum.DANGER);
formIncompletoToast.setMessage('Campo(s) obrigatório(s) e/ou inválido(s)!');

export default {
  name: 'TrfFormularioTarefaBase',
  components: {
    TrfGlobalLoader: defineAsyncComponent(() => import('../../../components/GlobalLoader/index.vue')),
    TrfHeader: defineAsyncComponent(() => import('../../../components/Header/index.vue')),
    TrfButton: defineAsyncComponent(() => import('../../../components/Button/index.vue')),
    TrfPaginaErro: defineAsyncComponent(() => import('../../../components/PaginaErro/index.vue')),
    TrfPreenchimentoForm: defineAsyncComponent(() => import('./components/PreenchimentoFormTarefa.vue')),
  },
  props: {
    statusTela: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formulario: new FormularioTarefa(),
      key: '',
      tarefaWebId: null,
      keyValida: true,
      isLoaded: false,
      configsBtnsView: {
        labelConfirma: 'Salvar',
        labelCancela: 'Cancelar',
        acaoConfirma: () => {},
        acaoCancela: () => {},
        isLoading: false
      },
      formId: null,
      isFormLoading: true,
      isVisualizacao: false,
      isBtnAConcluirLoading: false,
      ajustes: null,
    };
  },
  async beforeRouteEnter(to, from, next) {
    const isVisualizacao = to.path.includes('visualizar');
    const id = to.params.id;
    if (!!id && isVisualizacao) {
      next(async (vm) => {
        vm.isVisualizacao = true;
        vm.formId = id;
        await vm.getDadosDoFormulario();
      });
    } else {
      next(async (vm) => {
        vm.key = to.query.key;
        await vm.getDadosDoFormulario();
      });
    }
  },
  async beforeRouteUpdate(to) {
    const isVisualizacao = to.path.includes('visualizar');
    const id = to.params.id;
    if (!!id && isVisualizacao) {
      this.formId = id;
      this.isVisualizacao = true;
      this.isLoaded = false;
      await this.getDadosDoFormulario();
    } else {
      this.key = to.query.key;
      this.isLoaded = false;
      await this.getDadosDoFormulario();
    }
  },
  computed: {
    pageTitle() {
      return this.isVisualizacao ? 'Conferir formulário' : 'Formulário';
    },
    tituloErroNaoEncontrado() {
      return '<h1 class="is-size-3">Não foi possível acessar o formulário!</h1>'
    },
    mensagemErroNaoEncontrado() {
      return '<p>O item solicitado não foi encontrado ou já não existe mais.</p><p>Entre em contato com os responsáveis pelo envio.</p>'
    },
    isConferencia() {
      return this.isVisualizacao;
    },
    tooltipConfirmar() {
      return this.isVisualizacao? 'Confirmar a conferência do formulário.' : 'Salvar os dados e enviar para conferência.'
    },
    ajustesSanitizado() {
      return this.ajustes ? DOMPurify.sanitize(this.ajustes) : '';
    },
    formPersonalizado() {
      return this.formulario;
    }
  },
  methods: {
    async importFormularioService() {
      const { formularioTarefaService } = await import('../../../service/formulario-tarefa-service.js');
      return formularioTarefaService;
    },

    setConfigsBtnsView(labelConfirma, labelCancela, acaoConfirma, acaoCancela) {
      this.configsBtnsView.labelConfirma = labelConfirma;
      this.configsBtnsView.labelCancela = labelCancela;
      this.configsBtnsView.acaoConfirma = acaoConfirma;
      this.configsBtnsView.acaoCancela = acaoCancela;
    },
    setFormData(formData) {
      this.formulario = formData;
    },
    async getDadosDoFormulario() {
      if(this.isLoaded) return;
      try {
        this.isFormLoading = true;
        const formularioService = await this.importFormularioService();
        let response = {};

        if (!this.isVisualizacao) {
          const filtro = { key: this.key };
          response = await formularioService.getDadosPelaKey(filtro);
          this.setConfigsBtnsView('Salvar', 'Cancelar', this.salvarFormularioPelaKey, this.doVoltar);
        } else {
          response = await formularioService.getDadosPeloId(this.formId);
          this.setConfigsBtnsView('Confirmar', 'Fechar', this.doConfirmarDadosDoForm, this.doVoltar);
        }
        this.ajustes = response?.ajustes ? DOMPurify.sanitize(response.ajustes) : null;
        this.tarefaWebId = response?.tarefaWebId;
        
        // Verifica se formulário já foi enviado
        if (!this.isVisualizacao && response?.aConferir === false && response?.possuiTodasFasesConcluidas === true) {
          try {
            routerUtils._substituiRota('/formularios/responder/enviado');
          } catch (error) {
            console.warn('Navegação cancelada ou falhou:', error);
          }
          return;
        }
        
        this.formulario.asModel(response);
      } catch (e) {
        const errorMessage = e.message.toLowerCase();
        if (e.message.includes('404') || errorMessage.includes('parâmetros inválidos')) {
          this.keyValida = false;
        } else if (errorMessage.includes('aguardando')) {
          this.isFormLoading = false;
          this.isLoaded = true;
          routerUtils._substituiRota('/formularios/responder/enviado');
          return;
        } else if (e.message.includes('400')) {
          this.keyValida = false;
        }
        console.warn(`WARN: ${e}`);
      } finally {
        this.isFormLoading = false;
        this.isLoaded = true;
      }
    },
    async salvarFormularioPelaKey() {
      const validacaoPersonalizada = await this.doValidarDadosCadastro();
      try {
        if(!validacaoPersonalizada) {
          formIncompletoToast.toast()
          return;
        }

        this.configsBtnsView.isLoading = true;
        const formularioService = await this.importFormularioService();
        const requestBody = this.formulario.asRequestBody();
        requestBody.keyFormulario = this.key;
        requestBody.tarefaWebId = this.tarefaWebId;
        await formularioService.editarPelaKey(requestBody);
        routerUtils._substituiRota('/formularios/responder/enviado');
      } catch (e) {
        const message = e.message? e.message : 'Ocorreu um erro ao salvar as informações.';
        toastUtils.dangerToast(message); 
        console.warn(`WARN: ${e}`);
      } finally {
        this.configsBtnsView.isLoading = false;
      }
    },

    async doValidarDadosCadastro() {
      const resultadoValidacao = await this.$refs.formPreenchimento.doValidar();
      return resultadoValidacao;
    },
    async doConfirmarDadosDoForm() {
      try {
        this.configsBtnsView.isLoading = true;
        const formularioService = await this.importFormularioService();
        await formularioService.confirmarDados({ id: this.formId });
        toastUtils.successToast('Informações salvas com sucesso!');
        this.doVoltar();
      } catch (e) {
        toastUtils.dangerToast('Ocorreu um erro ao salvar as informações.');
        console.warn(`WARN: ${e}`);
      } finally {
        this.configsBtnsView.isLoading = false;
      }
    },
    doVoltar() {
      routerUtils._carregarNovaRota(`/tarefas-cliente`);
    },
    async aConcluirFormularioPelaKey() {
      try {

        this.isBtnAConcluirLoading = true;
        const formularioService = await this.importFormularioService();
        const requestBody = this.formulario.asRequestBody();
        requestBody.keyFormulario = this.key;
        requestBody.aConcluir = true;
        await formularioService.editarPelaKey(requestBody);
        toastUtils.successToast("Informações salvas com sucesso!");

        const currentUrl = window.location.href;
        routerUtils._substituiRota(`/formularios/responder/salvo?previousUrl=${currentUrl}`);
      } catch (e) {
        console.trace()
        toastUtils.dangerToast('Ocorreu um erro ao salvar as informações.');
        console.warn(`WARN: ${e}`);
      } finally {
        this.isBtnAConcluirLoading = false;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.ajustes {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border: 1px solid #faebcc;
  border-radius: 4px;
  overflow-wrap: anywhere;
}
</style>
